import React, { useCallback } from 'react';
import './implement-entity-icon.css';
import { EditorService } from '../../../services/editor';
import { EntityState } from '@elyx-code/project-logic-tree';
import { useCanvasPopup } from '../../../services/editor/CanvasPopup';
import { DraggableObject } from '../../../lib/canvas';
import CanvasPopupBaseComponent from '../../../lib/popup/CanvasPopupBaseComponent';

interface IImplementEntityIconProps {
	entity: EntityState;
	project: EditorService;
	draggableObject: DraggableObject;
	[key: string]: any;
}

const ImplementEntityIcon = (props: IImplementEntityIconProps) => {
	const memoizedCanvasPopupBody = useCallback(
		() => (
			<CanvasPopupBaseComponent containerClasses={['tooltip', 'tooltip--large-font']}>
				Click to add this suggestion
			</CanvasPopupBaseComponent>
		),
		[]
	);

	const canvasPopup = useCanvasPopup(
		{
			editor: props.project,
			id: 'implement-entity-icon--' + props.entity.id + '--popup',
			anchorQuerySelector: '#implement-entity-icon--' + props.entity.id,
			arrowClasses: ['tooltip-arrow'],
			parentCanvasObject: props.draggableObject,
			placement: 'top',
		},
		memoizedCanvasPopupBody,
	)
		.setupHover({
			closeDelay: 80,
			openDelay: 600,
		})
		.onBeforeShow(() => {
			if (
				// @ts-ignore
				(props.entity.suggestion && props.project.canvas?.isSelecting) ||
				props.project.canvas?.isMovingObjects
			) {
				return false;
			}
			return true;
		});

	const { draggableObject, project, entity, ...otherProps } = props;

	return (
		// @ts-ignore
		!!props.entity.suggestion && (
			<span
				id={'implement-entity-icon--' + props.entity.id}
				ref={canvasPopup.anchorRef}
			>
				<i
					{...otherProps}
					className={[
						'implement-entity-icon',
						'fa-solid',
						'fa-circle-plus',
					].join(' ')}
				/>
			</span>
		)
	);
};

export default ImplementEntityIcon;
